import React from "react";

const TicketAcknowledgedEmail: React.FC = () => {
    const htmlContent = `
        <div class="flex justify-center py-8 bg-gray-100 rounded-lg">
            <div class="max-w-[600px] mx-auto bg-white shadow-lg">
                <div class="bg-gradient-to-r from-blue-600 to-blue-700 px-8 py-6">
                    <h1 class="text-white text-2xl font-semibold">Service Desk</h1>
                </div>
                <div class="px-8 py-6">
                    <h2 class="text-2xl font-semibold text-gray-900 mb-4">Your Ticket Is Being Handled</h2>
                    <p class="text-gray-700 mb-6">Good news! Your support request has been acknowledged and an agent has taken ownership.</p>
                    <div class="border-l-4 p-4 mb-4 bg-green-50 border-green-200 text-green-800">
                        <p class="font-semibold mb-1">Assigned to Support Agent</p>
                        <p class="text-sm">A team member is now working on your request.</p>
                    </div>
                    <div class="bg-gray-50 p-4 rounded-md mb-6">
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Ticket ID:</span>
                            <span class="text-gray-900"><span class="font-mono text-blue-600">#SD-2024-1547</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Subject:</span>
                            <span class="text-gray-900">Unable to access customer database</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Assigned To:</span>
                            <span class="text-gray-900">Marcus Chen - Database Specialist</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Status:</span>
                            <span class="text-gray-900"><span class="inline-block bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm font-medium">Doing</span></span>
                        </div>
                    </div>
                    <div class="mb-6 bg-blue-50 border border-blue-200 p-4 rounded">
                        <h3 class="font-semibold text-gray-900 mb-2">Message from Marcus:</h3>
                        <p class="text-gray-700 text-sm">"Hi Sarah, I've started looking into your database access issue. I'm checking the authentication logs and user permissions now. I'll have an update for you within the next hour."</p>
                    </div>
                    <div class="mb-6">
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Expected Response:</span>
                            <span class="text-gray-900">Within 1 hour</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Target Resolution:</span>
                            <span class="text-gray-900">May 6, 2026 by 6:30 PM</span>
                        </div>
                    </div>
                    <div class="flex">
                        <a href="#" class="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">View Progress</a>
                    </div>
                    <div class="mt-6 pt-6 border-t border-gray-200">
                        <p class="text-sm text-gray-600">You'll receive updates as progress is made on your ticket. Feel free to add additional information at any time through the portal.</p>
                    </div>
                </div>
                <div class="bg-gray-50 px-8 py-6 border-t border-gray-200">
                    <p class="text-sm text-gray-600">This is an automated message from the Service Desk. Please do not reply directly to this email.</p>
                </div>
            </div>
        </div>
    `;
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default TicketAcknowledgedEmail;
